"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDateWithinNumMonths = function isDateWithinNumMonths(data) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;

    if (data && data.numberOfMonths) {
      // if toDate is not supplied use current date
      var fromDate = (0, _moment.default)();

      if (data.fieldID) {
        var fromDateStr = form.$(data.fieldID).value;

        if (fromDateStr) {
          fromDate = (0, _moment.default)(fromDateStr, 'DD/MM/YYYY');
        }
      }

      var toDate = fromDate.clone().add(data.numberOfMonths, 'months');
      var enteredDate = (0, _moment.default)(field.value, 'DD/MM/YYYY');
      var isValid = enteredDate.isBetween(fromDate.subtract(1, 'days'), toDate.add(1, 'days'));
      return [isValid, data.message || "Please enter a date within ".concat(data.numberOfMonths, " months of the current date")];
    }

    throw new Error('Data is required with numberOfMonths property defined');
  };
};

var _default = isDateWithinNumMonths;
exports.default = _default;
//# sourceMappingURL=isDateWithinNumMonths.js.map